import moment from 'moment-timezone'; 

export const timestamp = (unixTime) => { return moment.unix(unixTime).tz('America/Los_Angeles'); };
export const newMomentDay = () => { return moment().tz('America/Los_Angeles'); };
export const formatMomentDate = (dateToFormat) => { return moment(dateToFormat).tz('America/Los_Angeles').format('YYYY-MM-DD'); };
export const momentFromIso = (isoString) => { return moment(isoString).tz('America/Los_Angeles'); };